import { AlertTriangle, ArrowRight, X } from 'lucide-react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSubscription } from '../../contexts/SubscriptionContext';
import { useLocale } from '../../contexts/LocaleContext';

export default function GracePeriodBanner() {
  const { t } = useLocale();
  const { showGraceBanner, graceDaysRemaining, subscription } = useSubscription();
  const [dismissed, setDismissed] = useState(false);
  const navigate = useNavigate();

  if (!showGraceBanner || dismissed) return null;

  const urgent = graceDaysRemaining <= 1;
  const plan = subscription?.plan_name ?? '';

  const message = urgent
    ? t('subscriptionGate.lastChance').replace('{plan}', plan)
    : (graceDaysRemaining === 1
        ? t('subscriptionGate.gracePeriodDay')
        : t('subscriptionGate.gracePeriodDays')
      ).replace('{plan}', plan).replace('{days}', graceDaysRemaining);

  return (
    <div className="flex items-center gap-3 px-4 py-3 text-sm relative"
      style={{ backgroundColor: urgent ? 'var(--accent-danger)' : 'var(--accent-warning)', color: 'white' }}>
      <AlertTriangle className="w-4 h-4 flex-shrink-0" />
      <span className="flex-1 font-medium">{message}</span>
      <button
        onClick={() => navigate('/upgrade')}
        className="flex items-center gap-1.5 px-3 py-1 rounded-lg bg-white/20 hover:bg-white/30 font-semibold text-xs transition-all whitespace-nowrap">
        {t('subscriptionGate.renewNow')} <ArrowRight className="w-3 h-3" />
      </button>
      <button
        onClick={() => setDismissed(true)}
        className="p-1 rounded hover:bg-white/20 transition-all flex-shrink-0">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}